module.exports = __webpack_public_path__ + "img/img3.012361dc.png";